module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/bella-white-f825dafe17b47f1a8fedb984f6505481.jpg";